<template>
    <div v-if="dataIsLoaded" class="min-w-screen min-h-screen flex items-center justify-center">
        <div v-if="!nextEmail || !tokenIsValid" class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <p class="text-center">Похоже ссылка устарела</p>
            <p class="text-center">Попробуйте запросить письмо еще раз</p>
        </div>
        <div v-else-if="tokenIsValid" class="w-[700px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <div class="flex flex-col items-center gap-8">
                <div class="max-w-full">
                    <p class="mb-2 text-center text-lg">Вы уверены, что хотите изменить email на сервисе QKASSA?</p>
                    <p class="max-w-full overflow-x-scroll text-nowrap font-semibold no-scrollbar">{{  `${currentEmail} -> ${nextEmail}` }}</p>
                </div>
                <div class="flex items-center gap-4 w-full">
                    <button @click="resetEmail" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2">Установить новый email</button>
                    <button @click="cancelReset" class="w-full bg-red-500 hover:bg-red-600 text-center text-white font-medium rounded-lg text-sm px-5 py-2">Отменить действие</button>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';

    export default {
        name: "ResetPhone",
        components: {
            LoadingComponent,
        },
        computed: {
            ...mapState(["profileData"]),
        },
        data() {
            return {
                tokenIsValid: false,
                dataIsLoaded: false,
                token: null,
                currentEmail: null,
                nextEmail: null,
            }
        },
        methods: {
            async checkToken() {
                const token = this.$route.query.token;
                if (!token) {
                    this.dataIsLoaded = true;
                    return;
                }

                const result = await this.$store.dispatch("sendRequestToCheckTokenToChangeEmailFinal", token);
                if (result.successfully) {
                    this.tokenIsValid = true;
                    this.currentEmail = result.currentEmail;
                    this.nextEmail = result.nextEmail;
                }
                this.token = token;
                this.dataIsLoaded = true;
            },
            async resetEmail() {
                let result = await this.$store.dispatch("sendRequestToChangeEmailFinal", this.token);
                if (result.successfully) {
                    this.$notify("Ваш email успешно обновлен! Скоро вы будете перенаправлены на страницу входа...", "black");
                    await this.$store.dispatch("fetchProfileData");
                    setTimeout(() => {this.$router.push({name: "role"})}, 3000);
                }
            },
            async cancelReset() {
                let result = await this.$store.dispatch("sendRequestToCancelChangeEmail", this.token);
                if (result.successfully) {
                    this.$notify("Изменение email успешно отменено! Скоро вы будете перенаправлены на страницу входа...", "black");
                    setTimeout(() => {this.$router.push({name: "role"})}, 3000);
                }
            },
        },
        created() {
            this.checkToken();
        }
    }
</script>